<template>
  <div>
    <a-modal
      title="检验方式选择"
      :width="350"
      :visible="visible"
      :maskClosable="false"
      @cancel="close"
    >
      <div class="content">
        <a-radio-group button-style="solid" v-model="status" size="large">
          <a-radio-button
            v-for="item in statusOptions"
            :key="item.lookupCode"
            :value="item.lookupCode">
            {{ item.lookupValue }}
          </a-radio-button>
        </a-radio-group>
      </div>
      <template slot="footer">
        <a-button @click="close">取消</a-button>
        <a-button type="primary" :loading="nextConfirmLoading" @click="nextConfirm">确认</a-button>
      </template>
    </a-modal>
    <a-modal
      ref="createModal"
      title="成品质检"
      :width="1200"
      :visible="visibleNew"
      :maskClosable="false"
      @cancel="close"
      :footer="null"
      class="tableModal"
    >
      <div class="table-page-operator-wrapper">
        <a-button :loading="isSaveBtnLoading" :disabled="selectedRows.length === 0" @click="confirm()" type="primary">保存</a-button>
      </div>
      <a-table
        ref="modalTable"
        :loading="tableLoading"
        :columns="columns"
        :data-source="typeList"
        :pagination="false"
        row-key="lotNumber"
        :row-selection="rowSelection"
        :scroll="{ x: 800, y: 400 }"
      >
        <!-- 检验结果 -->
        <span slot="qualityStatusTitle">
          <i class="toRequired">*</i>检验结果
        </span>
        <template slot="qualityStatus" slot-scope="text, record">
          <a-select v-model="record.qualityStatus">
            <a-select-option v-for="(item) in qualityStatusList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
          </a-select>
        </template>
        <!-- 备注 -->
        <template slot="remarks" slot-scope="text, record">
          <a-select v-model="record.remarks" allowClear>
            <a-select-option v-for="(item) in remarksList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
          </a-select>
        </template>
        <!-- 检验时间 -->
        <template slot="inspectionTime" slot-scope="text">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
      </a-table>
      <!-- 底部分页按钮 -->
      <a-pagination
        class="ant-table-pagination"
        v-model="current"
        :page-size-options="pageSizeOptions"
        :total="total"
        show-size-changer
        :page-size="pageSize"
        @showSizeChange="onShowSizeChange"
        @change="currentPageChange"
      >
      </a-pagination>
    </a-modal>
  </div>
</template>

<script>
import { apiMesDispatchInspectMode, apiMesDispatchInspectionAssemblyCenter, apiMesDispatchInspectionQuality } from '@/api/mes/workOrderManage/workOrderSent'
export default {
  props: {},
  data () {
    return {
      tableLoading: false,
      currentId: "",
      // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      visible: false,
      statusOptions: [],
      status: "",
      visibleNew: false,
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          width: 150
        },
        {
          title: '成品',
          dataIndex: 'assembly',
          width: 150
        },
        {
          title: '规格描述',
          dataIndex: 'description',
          width: 150,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUomCode',
          width: 80
        },
        {
          title: '批次号',
          dataIndex: 'lotNumber',
          width: 150
        },
        {
          title: '检验方式',
          dataIndex: 'inspectModeName',
          width: 100
        },
        {
          // title: '检验结果',
          dataIndex: 'qualityStatus',
          scopedSlots: { customRender: 'qualityStatus', title: "qualityStatusTitle" },
          width: 150
        },
        {
          title: '不良原因',
          dataIndex: 'remarks',
          scopedSlots: { customRender: 'remarks' },
          width: 150
        },
        {
          title: '检验时间',
          dataIndex: 'inspectionTime',
          scopedSlots: { customRender: 'inspectionTime' },
          width: 150
        }
      ],
      typeList: [],
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      qualityStatusList: [], // 检验结果
      remarksList: [], // 备注
      isSaveBtnLoading: false, // 保存按钮loading
      nextConfirmLoading: false
    }
  },
  created () {
    this.getLookupList('INSPECT_MODE', 'statusOptions')
    this.getLookupList('QUALITY_STATUS', 'qualityStatusList')
    this.getLookupList('ADVERSE_CAUSES', 'remarksList')
  },
  methods: {
    // 检验方式选择
    show (id) {
      this.wipEntityId = id
      this.visible = true
    },
    // 成品质检
    showNew (id) {
      this.wipEntityId = id
      this.visibleNew = true
      this.getList()
    },
    nextConfirm () {
      if (!this.status) {
        this.$message.warning('请选择一种检验方式')
      }
      const param = {
        wipEntityId: this.wipEntityId,
        inspectMode: this.status
      }
      this.nextConfirmLoading = true
      apiMesDispatchInspectMode(param).then(res => {
        if (res.code === 200) {
          this.visible = false
          this.visibleNew = true
          this.getList()
        }
        this.nextConfirmLoading = false
      }).catch(e => {
        this.nextConfirmLoading = false
      })
    },
    // 保存
    confirm () {
      let flag = false
      const arr = []
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (!this.selectedRows[i].qualityStatus || (this.selectedRows[i].qualityStatus === "UNQUALIFIED" && !this.selectedRows[i].remarks)) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }

        const obj = {
          lotNumber: this.selectedRows[i].lotNumber,
          qualityStatus: this.selectedRows[i].qualityStatus,
          remarks: this.selectedRows[i].remarks
        }
        arr.push(obj)
      }
      if (flag) {
        return false
      }
      this.isSaveBtnLoading = true
      apiMesDispatchInspectionQuality(arr).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
          this.visibleNew = false
        } else {
          this.$message.error(response.msg)
        }
        this.isSaveBtnLoading = false
      }).catch(() => {
        this.isSaveBtnLoading = false
      })
    },
    close () {
      this.visible = false
      this.visibleNew = false
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    // 成品质检
    getList () {
      this.tableLoading = true
      apiMesDispatchInspectionAssemblyCenter(this.wipEntityId, { pageNum: this.current, pageSize: this.pageSize }).then(response => {
          this.typeList = response.data.list.rows
          this.total = response.data.list.total
          this.tableLoading = false
        }
      )
    },
    /** pageSize 变化的回调 */
    onShowSizeChange (current, pageSize) {
      this.current = current
      this.pageSize = pageSize
      this.getList()
    },
    /** 页码改变的回调 */
    currentPageChange (current, pageSize) {
      this.current = current
      this.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style scoped lang="less">
.tableModal{
  /deep/.ant-modal-body{
    // height: 400px;
    overflow-y: scroll;
  }
}
.content{
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.ant-select{
  width: 140px;
}
</style>
